export default "__VITE_ASSET__CMNNiChm__"